export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessonNumber : 6
            },
            {
                heading : "Learn CSS",
                description : "This course explores basic topics in CSS3, including animations, transitions, and layout techniques.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Responsive Web Design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes.",
                level : 'Intermediate',
                lessonNumber : 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "This course covers the detailed concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessonNumber : 6
            },
            {
                heading : "CSS",
                description : "This course explores advanced topics in CSS3, including animations, transitions, and layout techniques.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Javascript",
                description : "This course teaches JavaScript programming, enabling the creation of dynamic, interactive web applications across various platforms. ",
                level : 'Intermediate',
                lessonNumber : 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "This course covers the basic concepts of Java programming, including variables, control flow, and object-oriented programming principles.",
                level : 'Beginner',
                lessonNumber : 6
            },
            {
                heading : "Python",
                description : "This course covers the basic concepts of Python programming, including data types, control flow, and functions.",
                level : 'Beginner',
                lessonNumber : 6
            },
            {
                heading : "SCSS",
                description : "This course covers advanced topics in CSS3, including variables, mixins, and nesting.",
                level : 'Intermediate',
                lessonNumber : 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "This course covers the basics of web development with Flask, including routing, templates, and database integration.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Django",
                description : "This course covers the basics of web development with Django, including models, views, and templates.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Fast API",
                description : "This course covers the basics of building APIs with FastAPI, including routing, request handling, and validation.",
                level : 'Intermediate',
                lessonNumber : 6
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "This course covers the basics of building web applications with Next.js, including server-side rendering, data fetching, and routing.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Nuxt.js",
                description : "This course covers the basics of building web applications with Nuxt.js, including server-side rendering, routing, and Vuex state management.",
                level : 'Intermediate',
                lessonNumber : 6
            },
            {
                heading : "Sanity",
                description : "This course covers the basics of content management with Sanity, including schema design, content modeling, and API usage.",
                level : 'Intermediate',
                lessonNumber : 6
            },
        ]
    },
]
